import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getProject (params) { // 获取项目列表
    return axios.post(global.IMS_PROJECT + '/findAllProject', params)
  },
  addProject (params) { // 新增项目
    return axios.post(global.IMS_PROJECT + '/insertProject', params)
  },
  editProject (params) { // 编辑项目
    return axios.post(global.IMS_PROJECT + '/updateProject', params)
  },
  deleteProject (params) { // 删除项目
    return axios.post(global.IMS_PROJECT + '/deleteProject', params)
  },
  findProjectItem (params) { // 项目清单
    return axios.post(global.IMS_PROJECT + '/findProjectItem', params)
  },
  reportProject (params) { // 项目报备
    return axios.post(global.IMS_PROJECT + '/reportProject', params)
  },
  addToCart (params) { // 添加到购物车
    return axios.post(global.IMS_PROJECT + '/addToCart', params)
  },
  findPmcProductSpecByProductInfoId (params) { // 根据产品查规格
    return axios.post(global.EC_INFO + '/product/findPmcProductSpecByProductInfoId', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/member/project.js